import { yupResolver } from '@hookform/resolvers/yup';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  Link,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import type { Resolver } from 'react-hook-form';
import { Controller, useForm } from 'react-hook-form';
import * as Yup from 'yup';

import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Loader from '@/components/ui/Loader';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import type { CalculatorType } from '@/types/extension/CalculatorType';
import type {
  DueDateCalculatorJson,
  DueDateCalculatorRequest,
} from '@/types/extension/dueDateCalculatorRequest';

import form7004due from '../../data/form7004due.json';

declare global {
  interface Window {
    grecaptcha: any;
  }
}

const TaxCalculator = () => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const [isBtnLoader, setIsBtnLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [isPartnership, setIsPartnership] = useState(false);
  const [isNoOfficeInUS, setIsNoOfficeInUS] = useState(false);

  const [isShowCalculateButton, setShowCalculateButton] = useState(true);
  const [dueDate, setDueDate] = useState<Dayjs | null>(null);
  const [extdueDate, setExtDueDate] = useState<Dayjs | null>(null);

  // const taxYear = process.env.NEXT_PUBLIC_TAX_YEAR
  //   ? parseInt(process.env.NEXT_PUBLIC_TAX_YEAR, 10)
  //   : 0;
  const taxYear = 2025;
  const formcode = [
    { value: '2', text: '[02] Form 706-GS(T)' },
    { value: '3', text: '[03] Form 1041 (bankruptcy estate only)' },
    {
      value: '4',
      text: '[04] Form 1041 (estate other than a bankruptcy estate)',
    },
    { value: '5', text: '[05] Form 1041 (trust)' },
    { value: '6', text: '[06] Form 1041-N' },
    { value: '7', text: '[07] Form 1041-QFT' },
    { value: '8', text: '[08] Form 1042' },
    { value: '10', text: '[11] Form 1066' },
    { value: '13', text: '[15] Form 1120-F' },
    { value: '14', text: '[16] Form 1120-FSC' },
    { value: '15', text: '[17] Form 1120-H' },
    { value: '16', text: '[18] Form 1120-L' },
    { value: '17', text: '[19] Form 1120-ND' },
    { value: '18', text: '[20] Form 1120-ND (section 4951 taxes)' },
    { value: '19', text: '[21] Form 1120-PC' },
    { value: '20', text: '[22] Form 1120-POL' },
    { value: '21', text: '[23] Form 1120-REIT' },
    { value: '22', text: '[24] Form 1120-RIC' },
    { value: '24', text: '[26] Form 1120-SF' },
    { value: '25', text: '[27] Form 3520-A' },
    { value: '29', text: '[31] Form 8804' },
    { value: '12', text: '[34] Form 1120-C' },
    { value: '32', text: '[35] Form 8924' },
    { value: '33', text: '[36] Form 8928' },
  ];
  const taxPeriods = [
    // { value: `${taxYear}12`, text: `December - ${taxYear}` },
    { value: `${taxYear + 1}01`, text: `January - ${taxYear + 1}` },
    { value: `${taxYear + 1}02`, text: `February - ${taxYear + 1}` },
    { value: `${taxYear + 1}03`, text: `March - ${taxYear + 1}` },
    { value: `${taxYear + 1}04`, text: `April - ${taxYear + 1}` },
    { value: `${taxYear + 1}05`, text: `May - ${taxYear + 1}` },
    { value: `${taxYear + 1}06`, text: `June - ${taxYear + 1}` },
    { value: `${taxYear + 1}07`, text: `July - ${taxYear + 1}` },
    { value: `${taxYear + 1}08`, text: `August - ${taxYear + 1}` },
    { value: `${taxYear + 1}09`, text: `September - ${taxYear + 1}` },
    { value: `${taxYear + 1}10`, text: `October - ${taxYear + 1}` },
    { value: `${taxYear + 1}11`, text: `November - ${taxYear + 1}` },
  ];

  // form validation rules
  const validationSchema = Yup.object().shape({
    EmailAddress: Yup.string()
      .required('Email Address is required')
      .email('Enter valid Email Address'),
    Taxperiod: Yup.string()
      .required(' Tax Period End Month is required')
      .nullable(),

    Formcodeid: Yup.number().moreThan(0, 'Please choose the Formcode'),
    otherwise: Yup.string().nullable().notRequired(),
  });

  const defaultTaxCalculator: CalculatorType = {
    Taxperiod: '',
    Formcodeid: 0,
    EmailAddress: '',
    Source: '',
    IsNoOfficeInUS: false,
    IsPartnership: false,
  };

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<CalculatorType>({
    mode: 'onChange',
    resolver: yupResolver(validationSchema) as unknown as Resolver<
      CalculatorType,
      any
    >,
    defaultValues: defaultTaxCalculator,
  });

  const onChangeTaxyear = (
    Taxperiod: string,
    codeId: number,
    IsNoOfficeInUS: boolean,
    IsPartnership: boolean
  ) => {
    // let year = taxYear;
    // // if (Taxperiod !== `${taxYear}12`) {
    // //   year = taxYear + 1;

    const data: DueDateCalculatorJson[] = form7004due;

    const Duedate7004 = data?.find(
      (c) =>
        c.taxperiod === Taxperiod &&
        c.formcodeid === Number(codeId) &&
        c.taxyear === taxYear
    )?.duedate;
    // console.log('Duedate7004:', dueDate);

    const duedatefornonus = data?.find(
      (c) =>
        c.taxperiod === Taxperiod &&
        c.formcodeid === Number(codeId) &&
        c.taxyear === taxYear
    )?.duedatefornonus!;
    if (IsNoOfficeInUS === true || IsPartnership === true) {
      setDueDate(dayjs(duedatefornonus));
    } else {
      setDueDate(dayjs(Duedate7004));
    }

    // console.log(Duedate7004, Taxperiod, codeId, taxYear);
    const ExtDuedate7004 = data?.find(
      (c) =>
        c.taxperiod === Taxperiod &&
        c.formcodeid === Number(codeId) &&
        c.taxyear === taxYear
    )?.extendedduedate;
    const extendedduedatefornonus = data?.find(
      (c) =>
        c.taxperiod === Taxperiod &&
        c.formcodeid === Number(codeId) &&
        c.taxyear === taxYear
    )?.extendedduedatefornonus!;
    if (IsNoOfficeInUS === true || IsPartnership === true) {
      setExtDueDate(dayjs(extendedduedatefornonus));
    } else {
      setExtDueDate(dayjs(ExtDuedate7004));
    }
  };

  // async function decrementCounter() {
  //   const count = Number(getValues('TaxableVehicleCount'));
  //   if (count > 0) setValue('TaxableVehicleCount', count - 1);
  //   setShowCalculateButton(true);
  // }

  // async function incrementCounter() {
  //   const count = Number(getValues('TaxableVehicleCount'));
  //   setValue('TaxableVehicleCount', count + 1);
  //   setShowCalculateButton(true);
  // }

  const onChangeIsPartnership = (event: any) => {
    if (event.target.checked === true) {
      setIsPartnership(true);
    } else {
      setIsPartnership(false);
    }
  };

  const onChangeIsNoOfficeInUS = (event: any) => {
    if (event.target.checked === true) {
      setIsNoOfficeInUS(true);
    } else {
      setIsNoOfficeInUS(false);
    }
  };

  useEffect(() => {
    const loadScriptByURL = (id: any, url: any, callback: any) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        // eslint-disable-next-line func-names
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}&badge=bottomleft`,
      // eslint-disable-next-line func-names
      function () {
        // console.log('Script loaded!');
      }
    );
  }, []);
  const calculateTax = async (token: any, data: CalculatorType) => {
    onChangeTaxyear(
      data.Taxperiod,
      data.Formcodeid,
      data.IsNoOfficeInUS,
      data.IsPartnership
    );

    const postData: DueDateCalculatorRequest = {
      Source: 'Form 7004',
      EmailAddress: data.EmailAddress,
      Token: token,
    };

    const address = `/api/duedatecalculator/`;
    const contactusResponse = await fetch(address, {
      method: 'POST',
      body: JSON.stringify(postData),
    });
    const contactusResponseData = await contactusResponse.json();
    if (contactusResponseData?.status === 'Success') {
      setIsBtnLoader(false);
      // reset();
      // setSnackOpen(true);
    } else {
      setIsBtnLoader(false);
    }
    setShowCalculateButton(!isShowCalculateButton);

    // setShowCalculateButton(!isShowCalculateButton);
  };

  const onSubmit = async (data: CalculatorType) => {
    setIsLoading(true);
    setIsBtnLoader(true);

    if (isShowCalculateButton) {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, {
            action: 'submit',
          })
          .then(async (token: any) => {
            // console.log(token, data);
            await calculateTax(token, data);
          })
          .catch(() => {});
      });
    } else {
      router.push(
        `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup?emailaddress=${data.EmailAddress}`
      );
    }

    setIsLoading(false);
  };

  return (
    <AppLayout
      meta={
        <Meta
          title="Easily Calculate Your Form 7004 Extension Due Date (Free!)"
          description="Don't miss the deadline! Use TaxZerone's FREE Form 7004 Due Date Calculator to quickly determine your extended filing date for your business tax return."
          keywords="Form 7004 Due Date Calculator, HVUT Calculator, Form 2290, Truck tax calculator"
          canonical="tools/form-7004-due-date-calculator/"
        />
      }
    >
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Loader isLoading={isLoading} />
      <Container maxWidth="xl">
        <Hidden mdUp smDown>
          <Box
            sx={{
              mb: -1.5,
              textAlign: 'center',
              mt: 0,
              position: 'relative',
            }}
          >
            <Box
              component="picture"
              sx={{
                position: { xs: 'relative', sm: 'absolute' },
                right: 20,
                top: { xs: 0, sm: 20 },
              }}
            >
              <source
                srcSet="/assets/images/irs-authorized.webp"
                className="mw-100"
                width={50}
                height={49}
              />
              <source
                srcSet="/assets/images/irs-authorized.png"
                className="mw-100"
                width={50}
                height={49}
              />
              <img
                src="/assets/images/irs-authorized.png"
                loading="lazy"
                alt="IRS-authorized e-file provider"
                className="mw-100"
                width={50}
                height={49}
              />
            </Box>
          </Box>
        </Hidden>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Form 7004{' '}
                <span className="highlight-container">
                  <span className="highlight">Due Date Calculator</span>
                </span>{' '}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                <strong>Don&apos;t miss the deadline!</strong> Use our Form 7004
                Due Date Calculator to quickly and accurately determine the
                extended filing date for your business tax return.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href="#calculator"
                  >
                    Calculate 7004 Due Date Now
                  </Button>
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              className="banner-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/tools-due-date-img.webp" />
                <source srcSet="/assets/images/tools-due-date-img.png" />
                <img
                  src="/assets/images/tools-due-date-img.png"
                  alt="Form 7004 Due Date Calculator"
                  className="img-responsive-banner"
                  width={660}
                  height={544}
                />
              </picture>
            </Box>
          </Hidden>
          {/* <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="banner-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/tools-due-date-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/tools-due-dateimg-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/tools-due-date-img-sm.png"
                  alt="Form 7004 Due Date Calculator"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden> */}
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',

          mx: '0 !important',
          width: '100% !important',
          py: { xs: 1, sm: 3 },
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            pb={3}
            className="MuiGrid-root-width"
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Why Choose Our Form 7004 Due Date Calculator?
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Let go of the hassle of traditional tax filing methods and
                switch to the future of tax filing.
              </Typography> */}
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Quick and Easy"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Quick and Easy
                </Typography>
                <Typography variant="body1">
                  Enter a few details and get your due date in seconds.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/calculate-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/calculate-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/calculate-icon.png"
                      alt="Accurate"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Accurate
                </Typography>
                <Typography variant="body1">
                  Our calculator uses the latest IRS regulations to ensure
                  reliable results.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/free-efile-retransmission-icon.png"
                      alt="Free"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Free
                </Typography>
                <Typography variant="body1">
                  Use this tool as many times as you need, completely free of
                  charge.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      {/* Tax Calculator Section Start */}
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
          transition: 'all 0.3s ease 0s;',
          scrollMarginTop: 64,
        }}
        spacing={0}
        m={0}
        id="calculator"
      >
        <Container maxWidth="lg" sx={{ py: 5 }}>
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, md: 6.5, sm: 12 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Calculate your Business Tax Return’s due date in less than a
                  minute
                </Typography>

                <Typography
                  component="div"
                  variant="body1"
                  sx={{ mb: 3, color: '#6e6e6e' }}
                >
                  <ul
                    style={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                    }}
                  >
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 20,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{
                          color: '#1da94a',
                          mr: 1,
                          alignSelf: 'flex-start',
                        }}
                      />{' '}
                      <Typography>
                        <span style={{ fontWeight: 600 }}>Form Code:</span>{' '}
                        Select the appropriate form code from the dropdown menu.
                        This will depend on the specific type of business return
                        you are filing (e.g., Form 1120, Form 1120S).
                      </Typography>
                    </li>
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 20,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{
                          color: '#1da94a',
                          mr: 1,
                          alignSelf: 'flex-start',
                        }}
                      />{' '}
                      <Typography>
                        <span style={{ fontWeight: 600 }}>
                          Tax Period End Month:
                        </span>{' '}
                        Enter the month your tax period ended (e.g., December).
                      </Typography>
                    </li>
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 20,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{
                          color: '#1da94a',
                          mr: 1,
                          alignSelf: 'flex-start',
                        }}
                      />{' '}
                      <Typography>
                        <span style={{ fontWeight: 600 }}>
                          Foreign Corporation with No US Presence:
                        </span>{' '}
                        Check this box only if your organization is a foreign
                        corporation without an office or place of business in
                        the United States.
                      </Typography>
                    </li>
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{
                          color: '#1da94a',
                          mr: 1,
                          alignSelf: 'flex-start',
                        }}
                      />{' '}
                      <Typography>
                        <span style={{ fontWeight: 600 }}>
                          Qualifies under Regulations Section 1.6081-5:
                        </span>{' '}
                        Check this box only if your organization is a
                        corporation or partnership that meets the specific
                        qualifications outlined in this regulation
                      </Typography>
                    </li>
                  </ul>
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 0.5 }} />
            <Grid
              size={{ xs: 12, sm: 12, md: 5 }}
              textAlign="left"
              sx={{ pt: '0 !important' }}
            >
              <Box
                component="form"
                autoComplete="off"
                onSubmit={handleSubmit(onSubmit)}
                sx={{
                  border: '2px solid #ccc',
                  px: 3,
                  py: 4,
                  borderRadius: 4,
                  boxShadow: '0 0 20px rgba(0,0,0,.12)',
                  transition: 'all 0.3s ease 0s;',
                }}
              >
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    mt: -4,
                    mb: 1,
                    textAlign: 'center',
                    p: 2,
                  }}
                >
                  Form 7004 Due Date Calculator
                </Typography>
                <Stack direction="column" justifyContent="center" spacing={3}>
                  <FormControl sx={{ m: 0, minWidth: 150 }} fullWidth>
                    <InputLabel color="secondary">*Form Code</InputLabel>
                    <Controller
                      name="Formcodeid"
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <>
                          <Select
                            native
                            labelId="Formcodeid"
                            id="Formcodeid"
                            name="Formcodeid"
                            label="*Form Code"
                            error={!!error}
                            color="secondary"
                            value={value?.toString()}
                            onChange={(event) => {
                              onChange(event);
                              setShowCalculateButton(true);
                            }}
                            className={
                              Number(value) && Number(value) > 0
                                ? 'prefilled'
                                : 'mandatory-select'
                            }
                            sx={{
                              fontFamily: 'Poppins !important',
                            }}
                          >
                            <option aria-label="None" value={0} />
                            <optgroup
                              label="Most Common"
                              style={{
                                color: '#637381',
                                fontStyle: 'normal',
                                fontWeight: 500,
                                fontSize: 14,
                              }}
                            >
                              <option
                                key={11}
                                value={11}
                                style={{
                                  color: '#14181f',
                                  fontFamily: 'Poppins !important',
                                  fontWeight: 600,
                                  fontSize: 16,
                                }}
                              >
                                [12] Form 1120
                              </option>
                              <option
                                key={23}
                                value={23}
                                style={{
                                  color: '#14181f',
                                  fontFamily: 'Poppins !important',
                                  fontWeight: 600,
                                  fontSize: 16,
                                }}
                              >
                                [25] Form 1120-S
                              </option>
                              <option
                                key={9}
                                value={9}
                                style={{
                                  color: '#14181f',
                                  fontFamily: 'Poppins !important',
                                  fontWeight: 600,
                                  fontSize: 16,
                                }}
                              >
                                [09] Form 1065
                              </option>
                            </optgroup>
                            <optgroup
                              label="Others"
                              style={{
                                color: '#637381',
                                fontStyle: 'normal',
                                fontSize: 14,
                              }}
                            >
                              {formcode?.map(
                                (FormCategory: any, index: number) => (
                                  <option
                                    key={index}
                                    value={FormCategory.value}
                                    style={{
                                      color: '#14181f',
                                      fontFamily: 'Poppins !important',
                                      fontSize: 16,
                                    }}
                                  >
                                    {FormCategory.text}
                                  </option>
                                )
                              )}
                            </optgroup>
                          </Select>
                          {error && (
                            <FormHelperText error>
                              {error.message}
                            </FormHelperText>
                          )}
                        </>
                      )}
                    />
                  </FormControl>
                  <FormControl sx={{ m: 0, minWidth: 150 }} fullWidth>
                    <InputLabel color="secondary">
                      *Tax Period End Month
                    </InputLabel>
                    <Controller
                      name="Taxperiod"
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <>
                          <Select
                            native
                            labelId="taxyear"
                            name="taxyear"
                            id="TaxPeriodEndMonth"
                            label="*Tax Period End Month"
                            color="secondary"
                            error={!!error}
                            className={
                              Number(value) && Number(value) > 0
                                ? 'prefilled'
                                : 'mandatory-select'
                            }
                            value={value?.toString()}
                            onChange={(event) => {
                              onChange(event);
                              setShowCalculateButton(true);
                            }}
                          >
                            <option aria-label="None" value={0} />
                            <option
                              key={202512}
                              value={202512}
                              style={{
                                color: '#14181f',
                                fontFamily: 'Poppins !important',
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            >
                              December - 2025{' '}
                            </option>
                            {/* <option key="empty" value=""></option> */}

                            {taxPeriods.map((item, index: number) => {
                              return (
                                <option key={index} value={item.value}>
                                  {item.text}
                                </option>
                              );
                            })}
                          </Select>
                        </>
                      )}
                    />
                    {errors.Taxperiod && (
                      <FormHelperText error>
                        {errors.Taxperiod.message}
                      </FormHelperText>
                    )}
                  </FormControl>

                  <FormControlLabel
                    sx={{
                      backgroundColor: isNoOfficeInUS ? '#ecedf1' : '#fbfbfb',
                      borderRadius: 2,
                      px: 0.5,
                      py: 1,
                    }}
                    control={
                      <Controller
                        name="IsNoOfficeInUS"
                        control={control}
                        defaultValue={false}
                        render={({ field: { onChange, value } }) => (
                          <Checkbox
                            sx={{ alignSelf: 'flex-start', mr: 1 }}
                            id="Form7004.IsNoOfficeInUS"
                            name="Form7004.IsNoOfficeInUS"
                            checked={value}
                            onChange={(event) => {
                              onChange(event);
                              onChangeIsNoOfficeInUS(event);
                            }}
                            value={value}
                          />
                        )}
                      />
                    }
                    label={
                      <Typography
                        component="div"
                        sx={{ color: '#637381', flexGrow: 1 }}
                      >
                        Check here, if the organization is a foreign corporation
                        that does not have an office or place of business in the
                        United States
                      </Typography>
                    }
                  />

                  <FormControlLabel
                    sx={{
                      backgroundColor: isPartnership ? '#ecedf1' : '#fbfbfb',
                      borderRadius: 2,
                      px: 0.5,
                      py: 1,
                    }}
                    control={
                      <Controller
                        name="IsPartnership"
                        control={control}
                        defaultValue={false}
                        render={({ field: { onChange, value } }) => (
                          <Checkbox
                            sx={{ alignSelf: 'flex-start', mr: 1 }}
                            id="Form7004.IsPartnership"
                            name="Form7004.IsPartnership"
                            checked={value}
                            onChange={(event) => {
                              onChange(event);
                              onChangeIsPartnership(event);
                            }}
                            value={value}
                          />
                        )}
                      />
                    }
                    label={
                      <Typography
                        component="div"
                        sx={{ color: '#637381', flexGrow: 1 }}
                      >
                        Check here, if the organization is a corporation or
                        partnership that qualifies under Regulations section
                        1.6081-5
                      </Typography>
                    }
                  />

                  <FormControl sx={{ m: 0, minWidth: 150 }} fullWidth>
                    <Controller
                      name="EmailAddress"
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          className={value ? 'prefilled' : 'mandatory'}
                          id="EmailAddress"
                          label="*Email Address"
                          variant="outlined"
                          autoComplete="nope"
                          color="secondary"
                          inputProps={{
                            maxLength: 100,
                          }}
                          value={value}
                          onChange={onChange}
                          error={!!error}
                          helperText={error ? error.message : null}
                        />
                      )}
                    />
                  </FormControl>
                  {!isShowCalculateButton && !isLoading ? (
                    <Box
                      sx={{
                        textAlign: 'center',
                        transition: 'all 0.3s ease 0s;',
                        backgroundColor: '#fff4e5',
                        borderRadius: 3,
                        p: 2,
                      }}
                    >
                      Due Date:
                      <br />
                      <Box
                        component="b"
                        sx={{
                          fontSize: { xs: 20, md: 24 },
                          color: '#213e99',
                        }}
                      >
                        {dayjs(dueDate).format('MMM DD, YYYY')}
                      </Box>
                      <Box sx={{ fontWeight: 600 }}>
                        Extended Due Date:{' '}
                        <Box
                          component="span"
                          sx={{ color: '#1da94a', fontWeight: 700 }}
                        >
                          {dayjs(extdueDate).format('MMM DD, YYYY')}
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    ''
                  )}
                  <Box sx={{ textAlign: 'center' }}>
                    <LoadingButton
                      loading={isBtnLoader}
                      disabled={isBtnLoader}
                      type="submit"
                      variant="contained"
                      className="btn-primary"
                      sx={{
                        transition: 'all 0.3s ease 0s',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.1)',
                        },
                      }}
                    >
                      <span>
                        {isShowCalculateButton
                          ? 'Calculate Due Date'
                          : 'E-file Form 7004 Now'}
                      </span>
                    </LoadingButton>
                  </Box>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      {/* Tax Calculator Section End */}

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          E-File Form 7004 Efficiently with TaxZerone
        </Typography>
        <Container maxWidth="md" sx={{ px: 0 }}>
          <Typography
            variant="h3"
            sx={{
              fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              color: '#f3f3f3',
              mb: 3,
              lineHeight: 1.5,
            }}
          >
            While you&apos;re here, don&apos;t just calculate your due
            date—e-file your Form 7004 extension with TaxZerone! Our secure and
            user-friendly platform makes filing a breeze, saving you time and
            ensuring you get 6 months to file your business tax return.
          </Typography>
        </Container>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=7004duedatecalculator`}
          >
            E-file Form 7004 Now
          </Button>
          <Typography variant="body2" sx={{ mt: 1, color: '#dfeae1' }}>
            Takes less than a minute
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What are the common due dates for filing Form 7004?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    The due date for filing Form 7004 depends on the type of
                    business entity and the end date of your tax period. Here
                    are some common scenarios:
                    <ul>
                      <li style={{ marginBottom: 8 }}>
                        <span style={{ fontWeight: 600 }}>
                          Form 1120 (C corporations) and LLCs taxed as C
                          corporations:
                        </span>{' '}
                        April 15th (Extended Deadline - October 15th)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Form 1065 (partnerships), Form 1120S (S corporations),
                          and LLCs taxed as partnerships or S corporations:
                        </span>{' '}
                        March 15th (Extended Deadline - September 15th)
                      </li>
                    </ul>
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What if my calculated due date has already passed?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography>
                      Unfortunately, you cannot file Form 7004 itself if the due
                      date has already passed. However, you may still be able to
                      file your tax return with a reasonable cause explanation
                      to avoid penalties. It&apos;s crucial to act quickly and
                      consult with a tax professional immediately to discuss
                      your options and determine the best course of action.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. How do I e-file Form 7004 with TaxZerone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    Visit the{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 7004
                    </Link>{' '}
                    page for detailed information on TaxZerone&apos;s e-filing
                    process for Form 7004. This includes step-by-step
                    instructions, pricing information, and other helpful
                    resources to ensure a smooth and efficient filing
                    experience.
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-7004/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default TaxCalculator;
